import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { fetchUsePrepayment } from '../../../../actions/prepayment/usePrepaymentDetail'
import { PrepaymentDetails } from '..'
import { AppState } from '../../../../reducers'
import { UsePrepaymentDetailState } from '../../../../reducers/prepayment/usePrepaymentDetail'
import { useTranslation } from 'react-i18next'
import { Paper, Box, Typography, Button, Stack, Tooltip } from '@mui/material';
import { KeyboardReturnOutlined, VisibilityOutlined } from '@mui/icons-material';
import moment from 'moment';
import { formattedCurrency } from '../../../../utils/StringUtils'
import { PrepaymentDetailState } from '../../../../reducers/prepayment/prepaymentDetail'
import { fetchPrepayment, fetchPrepaymentDiscounts } from '../../../../actions/prepayment/prepaymentDetail'
import UsePrepayment from '../../../../models/UsePrepayment'
import { SessionState, isClient, isVendor } from '../../../../reducers/auth/session'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'
import { useThemeContext } from '../../../../theme/ThemeContext'
import { fetchOrders } from '../../../../actions/order/orderList'
import Order from '../../../../models/Order'
import { tableToStatusOrder } from '../../Orders'
import { PrepaymentDiscountsState } from '../../../../reducers/prepayment/prepaymentDiscounts'
import { GeneralDescState } from '../../../../reducers/generalDescList'
import { fetchGeneralDesc } from '../../../../actions/generalDesc'

interface Props {
  prepayment: PrepaymentDetailState
  prepaymentDiscounts: PrepaymentDiscountsState
  usePrepaymentDetail: UsePrepaymentDetailState
  generalDesc: GeneralDescState
  session: SessionState
}

const PrepaymentDetail: React.FC<Props> = ({ prepayment, prepaymentDiscounts, usePrepaymentDetail, session, generalDesc }) => {
  const dispatch = useDispatch()
  const params = useParams<{ prepaymentId: string, clientId?: string }>()
  const history = useHistory()
  const { t } = useTranslation(['prepayment', 'others'])
  const { theme } = useThemeContext()
  const [usePrepaymentData, setUsePrepaymentData] = useState<UsePrepayment[] | null>(null)

  useEffect(() => {
    dispatch(fetchGeneralDesc())
    dispatch(fetchPrepayment(params.prepaymentId, params.clientId, history.location.search, (response: any) => {
      const codigo_cliente = response.prepayment && response.prepayment.length > 0 ? response.prepayment[0].codigo_cliente : ''
      dispatch(fetchUsePrepayment(params.prepaymentId, params.clientId, history.location.search, (response: any) => {
        const toData = (response.usePrepaymentLines as UsePrepayment[]).filter(detail => !detail.id_utilizacion.includes('PD'))
        const toSearch = (response.usePrepaymentLines as UsePrepayment[]).filter(detail => detail.id_utilizacion.includes('PD'))
        dispatch(fetchOrders(`?orderId='${toSearch.map(item => item.id_utilizacion).join("','")}'${!isClient(session) ? `&codigo_cliente=${codigo_cliente}` : ''}`,
          (response: any) => {
            (response.orders as Order[]).forEach(order => {
              const index = toSearch.findIndex(item => item.id_utilizacion === order.id_pedido)
              if (index >= 0 && order && order.estados && order.estados.length > 0) {
                toSearch[index].estado = tableToStatusOrder(order.estados[0].estado_pedido, order.codigo_transporte)
                //order.estados[0].estado_pedido
              }
            }
            )
            dispatch(fetchPrepaymentDiscounts(params.prepaymentId, params.clientId, history.location.search))
            setUsePrepaymentData([...toData, ...toSearch])
          }))
      }))
    }))
  }, [dispatch, params.prepaymentId, params.clientId, history.location.search, session])


  const linkToOrderDetail = (usePrepayment: UsePrepayment) => {
    // TODO id_utilizacion tendria que venir ya en la tabla, pero por error no viene. Lo tiene que ver datalytics.

    const zeroPad = (num: any, places: number) => String(num).padStart(places, '0')

    const id_utilizacion = usePrepayment.id_utilizacion ? usePrepayment.id_utilizacion :
      `${usePrepayment.codigo_comprobante_utilizacion} ${zeroPad(usePrepayment.prefijo_comprobante_utilizacion, 4)}-${zeroPad(usePrepayment.numero_comprobante_utilizacion, 8)}`

    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/orders/detail/${id_utilizacion}${isVendor(session) && prepayment && prepayment.prepayment && prepayment.prepayment.length > 0 ? `&${prepayment.prepayment[0].codigo_cliente}` : ''}`
    history.push(detailUrl)
  }

  const linkToInvoiceDetail = (usePrepayment: UsePrepayment) => {
    // TODO id_utilizacion tendria que venir ya en la tabla, pero por error no viene. Lo tiene que ver datalytics.

    const zeroPad = (num: any, places: number) => String(num).padStart(places, '0')

    const id_utilizacion = usePrepayment.id_utilizacion && usePrepayment.id_utilizacion !== ' 0000-00000000' ? usePrepayment.id_utilizacion :
      prepayment && prepayment.prepayment && prepayment.prepayment.length > 0 ? prepayment.prepayment[0].id_factura :
        `${usePrepayment.codigo_comprobante_utilizacion} ${zeroPad(usePrepayment.prefijo_comprobante_utilizacion, 4)}-${zeroPad(usePrepayment.numero_comprobante_utilizacion, 8)}`

    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/accounts/detail/${id_utilizacion}${isVendor(session) && prepayment && prepayment.prepayment && prepayment.prepayment.length > 0 ? `&${prepayment.prepayment[0].codigo_cliente}` : ''}`
    history.push(detailUrl)
  }

  const tooltipText = (text: string) =>
    <Paper elevation={2} sx={{ padding: "10px" }}>
      <Typography sx={{ fontFamily: 'monospace', whiteSpace: 'pre-line' }} >{text}</Typography>
    </Paper>


  const HeaderDetail: React.FC = () => {

    return (
      <Paper elevation={2} sx={{ margin: "10px", padding: "2px 2px 2px 2px", bgcolor: theme.palette.success.main }}>
        <Paper elevation={2}
          style={{
            padding: "15px 15px 15px 15px", display: "flex", flexDirection: "column",
            textAlign: "justify", justifyContent: "space-around",
            borderRadius: "4px", margin: "4px"
          }}>
          {prepayment.prepayment && prepayment.prepayment.length > 0 &&
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('prepayment')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{prepayment.prepayment[0].id_acopio}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('date')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{moment(prepayment.prepayment[0].fecha).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('listPrice')}:&nbsp;&nbsp;</Typography>
                <Tooltip
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: '900px',
                        whiteSpace: 'pre-line',
                      }
                    }
                  }}
                  title={
                    prepaymentDiscounts &&
                    prepaymentDiscounts.prepaymentDiscounts &&
                    tooltipText(
                      `${t('discounts')}:\n ${prepaymentDiscounts.prepaymentDiscounts
                        .sort((a, b) => a.codigo_familiadebonificaciones - b.codigo_familiadebonificaciones)
                        .map((fam) =>
                          `${String(generalDesc.generalDesc?.find(desc => desc.type === 'dsc' && desc.code === fam.codigo_familiadebonificaciones.toString())?.description ||
                            '\u00A0\u00A0').padEnd(23, `\u00A0`)}${`\u00A0`}${Array.from({ length: 10 }, (_, i) => String(Number(fam[`bonificacion${i + 1}`]).toFixed(2)).padStart(8, '\u00A0')) // Extraer las bonificaciones
                              .filter((value) => Number(value) !== 0) // Filtrar solo las bonificaciones distintas de cero
                              .join(`%\u00A0\u00A0`)
                          }` // Unir las bonificaciones válidas con comas
                        )
                        .filter((bonifications) => bonifications.length > 0) // Filtrar familias sin bonificaciones válidas
                        .join('%\u00A0\n') // Unir las familias con saltos de línea
                      }%`
                    )
                  }>
                  <Box display={"flex"} alignItems="center" sx={{ cursor: "pointer" }} flexDirection={"row"}>
                    <Typography variant="h6">{prepayment.prepayment[0].codigo_listadeprecios}&nbsp;&nbsp;</Typography>
                    <VisibilityOutlined  sx={{ color: theme.palette.success.main }}/>
                  </Box>
                </Tooltip>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('origin')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{formattedCurrency(prepayment.prepayment[0].importe)}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('balance')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{formattedCurrency(usePrepaymentDetail.usePrepaymentLines ?
                  usePrepaymentDetail.usePrepaymentLines.reduce((neto, usePrepayment) =>
                    neto + Number(usePrepayment.codigo_comprobante_utilizacion ? usePrepayment.importe_comprobante_utilizacion : usePrepayment.importe), 0) : 0)}</Typography>
              </Box>
            </Box>}
        </Paper>
      </Paper>
    )
  }

  return (
    <Stack style={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100% - var(--header-height)' }}>
      <HeaderDetail />
      <PrepaymentDetails
        //rows={(usePrepaymentDetail.usePrepaymentLines && usePrepaymentDetail.usePrepaymentLines.length > 0 ? usePrepaymentDetail.usePrepaymentLines : [])}
        rows={usePrepaymentData || []}
        loading={usePrepaymentDetail.isFetching || usePrepaymentData === null}
        pagination={usePrepaymentDetail.pagination || undefined}
        id_factura={(prepayment && prepayment.prepayment && prepayment.prepayment.length > 0 && prepayment.prepayment[0].id_factura) || undefined}
        onClickOrderDetail={linkToOrderDetail}
        onClickInvoiceDetail={linkToInvoiceDetail}
      />
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        <Button color="secondary" variant="contained" sx={{ textTransform: "none", margin: "10px" }} startIcon={<KeyboardReturnOutlined />} onClick={() => history.goBack()}>{t("back", { ns: 'others' })}</Button>
      </Box>
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  prepayment: state.prepaymentDetail,
  prepaymentDiscounts: state.prepaymentDiscounts,
  usePrepaymentDetail: state.usePrepaymentDetail,
  generalDesc: state.generalDescList,
  session: state.session
})


export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(PrepaymentDetail);